import { BASE_URL } from 'constants/api';

import actions from './index';

export const ACTIONS = {
  GET: 'STUDENT_COURSE_CLASSES_TRANSFER_GET',
  GET_SUCCESS: 'STUDENT_COURSE_CLASSES_TRANSFER_GET_SUCCESS',
  GET_FAILURE: 'STUDENT_COURSE_CLASSES_TRANSFER_GET_FAILURE',
  PATCH: 'STUDENT_COURSE_CLASSES_TRANSFER_PATCH',
  PATCH_SUCCESS: 'STUDENT_COURSE_CLASSES_TRANSFER_PATCH_SUCCESS',
  PATCH_FAILURE: 'STUDENT_COURSE_CLASSES_TRANSFER_PATCH_FAILURE',
};

export const get = actions.get(
  student_course_id => `${BASE_URL}/student-course-classes-transfer/${student_course_id}`,
  {
    PENDING: ACTIONS.GET,
    SUCCESS: ACTIONS.GET_SUCCESS,
    FAILURE: ACTIONS.GET_FAILURE,
  },
);

export const patch = actions.patch(
  student_course_id => `${BASE_URL}/student-course-classes-transfer/${student_course_id}`,
  {
    PENDING: ACTIONS.PATCH,
    SUCCESS: ACTIONS.PATCH_SUCCESS,
    FAILURE: ACTIONS.PATCH_FAILURE,
  },
);
